import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

/**
 * @param orgId
 */
class PaymentTermService {
  /**
   *
   * @param payload
   * @return {Promise<*>}
   */
   createPaymentTerm = async (payload) => {
     const createdPaymentTerm = await Helpers.put({
       url: Constants.PAYMENT_TERMS,
       data: payload,
     });
     return createdPaymentTerm;
   };

  /**
   * @param orgId
   * @param page
   * @param limit
   * @param searchKeyword
   * @return {Promise<*>}
   */
  getPaymentTerms = async (orgId, page, limit, searchKeyword) => {
    let url = `${Constants.PAYMENT_TERMS}?`;
    if (orgId) url += `org_id=${orgId}&`;
    if (page) url += `page=${page}&`;
    if (limit) url += `limit=${limit}&`;
    if (searchKeyword) url += `search_keyword=${searchKeyword}&`;

    const paymentTerms = Helpers.get({ url });
    return paymentTerms;
  };

  /**
   * @param payload
   * @return {Promise<*>}
   */
  updatePaymentTerm = async (payload) => {
    const updatePaymentTerm = await Helpers.put({
      url: Constants.PAYMENT_TERMS,
      data: payload,
    });
    return updatePaymentTerm;
  };

  /**
   *
   * @param {*} payload
   * @return
   */
  deletePaymentTerm = async (payload) => {
    const paymentTerm = await Helpers.delete({
      url: Constants.PAYMENT_TERMS,
      data: payload,
    });
    return paymentTerm;
  }
}
export default new PaymentTermService();
